import React, { useEffect, useState } from 'react';
import { maxBid } from '../domain/team';

// Conferma dell'assegnazione. Solo il banditore vede i controlli, ma soprattutto
// solo il banditore puo eseguirli: prima il server non verificava affatto chi
// inviasse il comando, quindi nascondere l'interfaccia era l'unica "sicurezza".

export default function AuctionResultPanel({
    lot,
    participants,
    teams,
    playersPerTeam,
    catalogue,
    isAuctioneer,
    onConfirm,
    onCancel,
}) {
    const [winnerId, setWinnerId] = useState(lot?.leading_participant_id ?? '');
    const [price, setPrice] = useState(String(lot?.current_bid ?? 1));

    useEffect(() => {
        setWinnerId(lot?.leading_participant_id ?? '');
        setPrice(String(lot?.current_bid ?? 1));
    }, [lot?.id, lot?.leading_participant_id, lot?.current_bid]);

    if (!lot) return null;

    const player = catalogue[lot.player_id];
    const leader = participants.find((participant) => participant.id === lot.leading_participant_id);
    const parsedPrice = Number.parseInt(price, 10);
    const ceiling = winnerId ? maxBid(teams[winnerId], playersPerTeam) : 0;
    const priceValid = Number.isInteger(parsedPrice) && parsedPrice >= 1 && parsedPrice <= ceiling;

    // Con la base a nessuno un lotto puo' chiudersi senza una sola offerta:
    // qui non c'e' niente da assegnare, e dirlo e' meglio che mostrare una
    // scelta del vincitore che sembra gia' fatta.
    const noBids = !lot.leading_participant_id;
    const fullName = player?.['Nome Completo'] ?? lot.player_name;
    const surname = player?.Cognome || fullName;

    return (
        <section className="panel">
            <div className="panel-header">
                <h2 className="panel-title">Asta terminata</h2>
            </div>
            <div className="panel-body stack">
                {/* Stessa forma della scheda del lotto, senza orologio: il lotto
                    e lo stesso, e cambiarne l'aspetto proprio al momento della
                    conferma costringerebbe a ritrovarsi. */}
                <div className="lot lot--settled">
                    <h3 className="lot-name">{surname}</h3>
                    <p className="lot-meta">
                        <span className="badge badge--role" data-role={lot.role}>
                            {lot.role}
                        </span>
                        {player?.Squadra && <span>{player.Squadra}</span>}
                    </p>
                    <div className="lot-bid">
                        <span className="lot-bid-value">{lot.current_bid}</span>
                        <span className="lot-leader">
                            <span className="u-caps">
                                {noBids ? 'Offerte' : 'Vincitore'}
                            </span>
                            <span className="lot-leader-name">
                                {noBids ? 'Nessuna' : (leader?.name ?? 'Nessuno')}
                            </span>
                        </span>
                    </div>
                </div>

                {isAuctioneer ? (
                    <>
                        <div className="field">
                            <label className="field-label" htmlFor="winner">
                                Assegna a
                            </label>
                            <select
                                id="winner"
                                className="select"
                                value={winnerId}
                                onChange={(event) => setWinnerId(event.target.value)}
                            >
                                {noBids && <option value="">Nessuno</option>}
                                {participants.map((participant) => (
                                    <option key={participant.id} value={participant.id}>
                                        {participant.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="field">
                            <label className="field-label" htmlFor="price">
                                Prezzo (max {ceiling})
                            </label>
                            <input
                                id="price"
                                type="number"
                                min="1"
                                max={ceiling}
                                className={`input${priceValid ? '' : ' input--invalid'}`}
                                value={price}
                                onChange={(event) => setPrice(event.target.value)}
                                aria-invalid={!priceValid}
                            />
                            {!priceValid && (
                                <p className="field-hint field-hint--stop">
                                    Inserisci un intero fra 1 e {ceiling}.
                                </p>
                            )}
                        </div>
                        <div className="panel-actions">
                            <button
                                type="button"
                                className="btn btn--go"
                                disabled={!priceValid || !winnerId}
                                onClick={() => onConfirm(winnerId, parsedPrice)}
                            >
                                Conferma
                            </button>
                            <button type="button" className="btn btn--stop" onClick={onCancel}>
                                {noBids ? 'Nessuno lo prende' : 'Annulla'}
                            </button>
                        </div>
                    </>
                ) : (
                    <p className="u-dim">
                        In attesa che il banditore confermi l&apos;assegnazione.
                    </p>
                )}
            </div>
        </section>
    );
}
